import styled from "styled-components";

import { colorsPalettes, fonts, setFont, setFontVariant } from "@similarweb/styles";

export const StyledManagementSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 28px;

    ${setFont({
        $size: 14,
        $weight: "normal",
        $family: fonts.$robotoFontFamily,
        $color: colorsPalettes.carbon[400],
    })};

    & button {
        ${setFont({
            $size: 14,
            $weight: "bold",
            $family: fonts.$dmSansFontFamily,
            $color: colorsPalettes.carbon[0],
        })};
    }
`;

export const StyledManagementHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    margin-bottom: 4px;

    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    line-height: 32px;
`;

export const StyledManagementSection = styled.div<{ disabled?: boolean }>`
    display: flex;
    flex-direction: row;
    margin-bottom: 24px;
    box-shadow: 0px 3px 6px rgba(14, 30, 62, 0.08);
    ${({ disabled }) => disabled && { opacity: 0.5, "pointer-events": "none" }}
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 4px;

    &.with-extra-padding {
        margin-bottom: 28px;
    }
`;

export const StyledImg = styled.img`
    height: 144px;
    width: 144px;
`;

export const StyledExtensionImg = styled.img`
    height: unset;
    width: 144px;
    border-radius: 10px;
`;

export const StyledImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 188px;
    background: ${colorsPalettes.bluegrey[200]};
    border-radius: 4px 4px 0px 0px;
`;

export const StyledSectionInfoWrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin: 0 40px;

    .suppression-list {
        margin-top: 8px;
    }
`;

export const StyledSectionTitle = styled.div`
    ${setFontVariant("h6", colorsPalettes.carbon[400])};
    line-height: 20px;
    margin-top: 16px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
`;

export const StyledTitleText = styled.div`
    display: flex;
    align-items: center;
    margin-right: 7px;
    ${setFontVariant("h6", colorsPalettes.carbon[400])};
`;

export const StyledSectionInfo = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;

    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    line-height: 20px;

    .suppression-list {
        justify-content: center;
    }
`;

export const StyledActionsPanel = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledList = styled.ul`
    padding: 8px 10px 8px 10px;
    list-style-type: disc;
    padding-bottom: 0px;

    .salesforce {
        margin-bottom: 16px;
    }
`;

export const StyledEnrichmentList = styled.ul`
    padding: 0 0 0 10px;
    list-style-type: disc;
    padding-bottom: 0px;
    margin: 0 0 0 8px;
`;
export const StyledSubList = styled.ul`
    padding: 7px 0 8px 10px;
    list-style-type: circle;
    padding-bottom: 0px;
    margin-left: 8px;
`;

export const StyledNameContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;

    ${setFontVariant("listItem3", colorsPalettes.carbon[300])};

    line-height: 16px;
    color: ${colorsPalettes.carbon[300]};

    &:first-letter {
        text-transform: uppercase;
    }
`;

export const StyledTimeContainer = styled(StyledNameContainer)`
    display: block;
`;

export const StyledSubHeadline = styled.h2`
    line-height: 20px;
    margin: 24px 0px 12px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
`;

export const StyledIntegrationTimeContainer = styled.div`
    margin-bottom: 7px;
`;

export const StyledNotConnectedSection = styled.div`
    padding-top: 10px;
    padding-bottom: 10px;
`;

export const StyledTable = styled.div<{ quantity: number }>`
    display: grid;
    margin-top: 4px;
    grid-template-columns: repeat(${({ quantity }) => quantity}, auto);
    border-left: 1px solid ${colorsPalettes.carbon[50]};
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 3px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    ${setFontVariant("caption", colorsPalettes.carbon[200])};
    line-height: 24px;
    background: ${colorsPalettes.carbon[0]};
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }

    & > div {
        border-right: 1px solid ${colorsPalettes.carbon[50]};
        border-bottom: 1px solid ${colorsPalettes.carbon[50]};
        padding: 0 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    & > div.header-cell {
        color: ${colorsPalettes.carbon[300]};
        background: ${colorsPalettes.carbon[25]};
    }
`;

///////////////////////////////
// SALESFORCE section styles //
///////////////////////////////

export const StyledConnectIconWrapper = styled.div`
    margin-right: 6px;
`;
